<script>
    export let confirmed_flag;
    export let show_confirm_flag;
    export let confirm_title = 'Confirmation';
    export let confirm_text = 'Are you sure?';
    export let confirm_yes_label = 'No';
    export let confirm_no_label = 'Cancel';
    export let confirm_yes_action;
    export let confirm_no_action = () => { 
        confirmed_flag = false; 
        show_confirm_flag = false; 
    };
</script>


<style>
    .confirm {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-around;
        box-sizing: border-box;
        z-index: 10000;
    }

    .hidden { 
        display: none
     }

    .panel {
        /*margin: 15% auto 0;*/
        /*min-width: 300px;*/
        /*width: 30%;*/
        /*border: 2px solid #336699;*/
        /*padding: 1em;*/
        /*color: #336699;*/
        /*background-color: white;*/
        text-align: center;
        border-radius: 4px;
        max-height: calc(100% - 32px);
        max-width: 560px;
        min-width: 280px;
        background-color: #fff;
        background-color: var(--mdc-theme-surface, #fff);
        box-shadow: 0px 11px 15px -7px rgba(0, 0, 0, 0.2),0px 24px 38px 3px rgba(0, 0, 0, 0.14),0px 9px 46px 8px rgba(0,0,0,.12);
        display: flex;
        flex-direction: column;
        flex-grow: 0;
        flex-shrink: 0;
        box-sizing: border-box;
        pointer-events: auto;
        overflow-y: auto;
        z-index: 2;
    }

    .panel-head {
        padding: 0.5em;
        margin-bottom: 1em;
        border-bottom: 1px solid #336699;
    }

    .panel-head h4 {
        text-align: center;
        font-weight: bold;
        color: #336699
    }

    .panel-body { 
        padding: 1em 1em 2em;
        text-align: left;
    }

    .panel-footer {
        border-top: 1px solid #336699;
        padding: 1em;
        margin-top: 1em;
        text-align: right;
    }

    .panel-footer button { 
        color: #336699;
        padding: 5px 10px;
        border: 2px solid #336699;
        margin: 0 0.5em;
        border-radius: 3px;
    }

    .panel-footer button:hover {
        color: white;
        background-color: #336699;
        border: 1px solid #336699;
        font-weight: bold;
        outline: 0;
        padding: 4px 9px;
    }

    .panel-footer button:focus {
        outline: 0;
    }

    .mdc-dialog__content {
        font-family: Roboto, sans-serif;
        -moz-osx-font-smoothing: grayscale;
        -webkit-font-smoothing: antialiased;
        font-size: 1rem;
        line-height: 1.5rem;
        font-weight: 400;
        letter-spacing: .03125em;
        text-decoration: inherit;
        text-transform: inherit;
        flex-grow: 1;
        box-sizing: border-box;
        margin: 0;
        padding: 20px 24px;
        padding-top: 20px;
        overflow: auto;
        -webkit-overflow-scrolling: touch;
    }

</style>


<div class="confirm" class:hidden={!show_confirm_flag}>
<!--    <div class="mdc-dialog__surface">-->
    <div class="panel">
        <div class="mdc-dialog__title">
            {confirm_title}
        </div>

        <div class="mdc-dialog__content">
            {confirm_text}
        </div>

        <footer class="mdc-dialog__actions">
            <button id={confirm_no_label}
                    class="mdc-button"
                    on:click={confirm_no_action}>
                {confirm_no_label}
            </button>
            <button
                    class="mdc-button mdc-button--raised"
                    style="margin: 1em;"
                    id={confirm_yes_label}
                    on:click={async () => {  await confirm_yes_action() }}>
                {confirm_yes_label}
            </button>
        </footer>

<!--        <div class="panel-footer">-->
<!--            <button class="confirm_no"-->
<!--                    id={confirm_no_label} -->
<!--                    on:click={confirm_no_action}>-->
<!--                {confirm_no_label}-->
<!--            </button>-->
<!--            <button class="confirm_yes" -->
<!--                    id={confirm_yes_label}-->
<!--                    on:click={confirm_yes_action}>-->
<!--                {confirm_yes_label}-->
<!--            </button>-->
<!--        </div>-->
    </div>
    <div class="mdc-dialog__scrim" style="background-color: rgba(0,0,0,.32); opacity: 1; z-index: 1;"></div>
</div>
